import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAdminComponent implements OnInit {
    public stats: any = {
        users: 0,
        collections: 0,
        datasets: 0,
        finetune_datasets: 0,
        instruction_datasets: 0,
        qa_pairs: 0,
        recent_collections: []
    };

    public pipeline: any = { originals: 0, ocr: 0, embedding: 0, vector: 0, milvus_rows: 0 };
    public pipelineLoading: boolean = true;
    public collectionStats: any = {};
    public stages: any[] = [];
    public pipelineTab: string = 'collection';
    public showQaMenu: boolean = false;
    public datasetStats: any = { status_counts: {}, total_qa: 0, reviewed_qa: 0, recent: [] };
    public datasetStatsLoading: boolean = false;
    public datasetType: string = 'finetune';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadStats();
        await this.service.render();
        this.loadPipelineStats();
        this.loadDatasetStats();
    }

    public async loadStats() {
        const { code, data } = await wiz.call('stats');
        if (code === 200) {
            this.stats = data;
        }
    }

    public async loadPipelineStats() {
        this.pipelineLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('pipeline_stats');
        if (code === 200) {
            this.pipeline = data.pipeline;
            this.collectionStats = data.collection_stats || {};
            this.buildStages();

            for (const col of this.stats.recent_collections) {
                const cs = this.collectionStats[col.id];
                if (cs) {
                    col.originals = cs.originals;
                    col.ocr = cs.ocr;
                    col.embedding = cs.embedding;
                    col.vector = cs.vector;
                    col.milvus_rows = cs.milvus_rows;
                }
            }
        }
        this.pipelineLoading = false;
        await this.service.render();
    }

    public async loadDatasetStats() {
        this.datasetStatsLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('dataset_stats', { type: this.datasetType });
        if (code === 200) {
            this.datasetStats = data;
        }
        this.datasetStatsLoading = false;
        await this.service.render();
    }

    public async setPipelineTab(tab: string) {
        this.pipelineTab = tab;
        await this.service.render();
    }

    public async setDatasetType(type: string) {
        this.datasetType = type;
        await this.loadDatasetStats();
    }

    public get datasetReviewRate(): number {
        const t = this.datasetStats.total_qa || 0;
        if (!t) return 0;
        return Math.round((this.datasetStats.reviewed_qa || 0) / t * 100);
    }

    public dsStatusLabel(status: string): string {
        const map: any = { draft: '초안', generating: '생성 중', review: '검수 중', completed: '완료' };
        return map[status] || status;
    }

    public dsStatusColor(status: string): string {
        const map: any = {
            draft: 'text-zinc-400',
            generating: 'text-amber-400',
            review: 'text-violet-400',
            completed: 'text-emerald-400'
        };
        return map[status] || 'text-zinc-400';
    }

    public dsStatusBg(status: string): string {
        const map: any = {
            draft: 'bg-slate-500',
            generating: 'bg-amber-500',
            review: 'bg-violet-500',
            completed: 'bg-emerald-500'
        };
        return map[status] || 'bg-slate-500';
    }

    public get datasetDetailPath(): string {
        return this.datasetType === 'instruction' ? '/dataset/instruction/' : '/dataset/finetune/';
    }

    private buildStages() {
        const p = this.pipeline;
        this.stages = [
            {
                label: '원본 문서', icon: 'fa-file-alt',
                count: p.originals, rate: 0, pending: 0,
                bg: 'bg-slate-500', bar: '', isFirst: true,
            },
            {
                label: 'OCR', icon: 'fa-magic',
                count: p.ocr,
                rate: this.getRate(p.ocr, p.originals),
                pending: Math.max(0, p.originals - p.ocr),
                bg: 'bg-emerald-500', bar: 'bg-emerald-400', isFirst: false,
            },
            {
                label: '임베딩', icon: 'fa-brain',
                count: p.embedding,
                rate: this.getRate(p.embedding, p.ocr),
                pending: Math.max(0, p.ocr - p.embedding),
                bg: 'bg-violet-500', bar: 'bg-violet-400', isFirst: false,
            },
            {
                label: '벡터 DB', icon: 'fa-database',
                count: p.vector,
                rate: this.getRate(p.vector, p.embedding),
                pending: Math.max(0, p.embedding - p.vector),
                bg: 'bg-blue-500', bar: 'bg-blue-400', isFirst: false,
            },
        ];
    }

    public getRate(done: number, total: number): number {
        if (!total) return 0;
        return Math.round((done / total) * 100);
    }

    public get userName(): string {
        return this.service.auth.session?.name || '관리자';
    }

    public formatNumber(n: number): string {
        if (n == null) return '0';
        return n.toLocaleString();
    }

    public navigateTo(path: string) {
        this.service.href(path);
    }
}

export default PageAdminComponent;